import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GroupPreviewPage, Orientation, } from "../../types/global";
import { useGroupData, useGroupLook } from "../../stores/useGroupStore";
import React from "react";
import GenericSwiper from "../helpers/GenericSwiper";
import { checkContentLockedForUser, formatContentDuration, formatSchedulingDate, getContentPurchaseTypes, getContentRedirectUrl, sectionToContentType, } from "../../lib/utils";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useTranslation } from "react-i18next";
import { useAutoplay } from "../../hooks/useAutoplay";
export default function ContentWatchSectionSwiper({ data, selectedId, className, showAutoplay, swiperOrientation, onReachEnd, onAutoplayChange, }) {
    const { t } = useTranslation();
    const groupLook = useGroupLook();
    const groupData = useGroupData();
    const contentType = sectionToContentType(data.type);
    const intermediatePage = groupLook.look?.info.preview_page;
    const dataLocation = swiperOrientation == Orientation.Landscape ? "bottom" : "right";
    const slides = data.content_list?.map((content) => {
        const contentObj = content;
        const image = contentObj.image
            ? JSON.parse(contentObj.image)
            : null;
        const flags = JSON.parse(contentObj.flags);
        const info = typeof contentObj.info === "string"
            ? JSON.parse(contentObj.info)
            : contentObj.info;
        const duration = info?.duration
            ? formatContentDuration(info?.duration, t)
            : null;
        const targetDate = formatSchedulingDate(info?.change_datetime, info?.change_timezone);
        const ageRestriction = info?.age_restriction ?? null;
        const locked = checkContentLockedForUser({ id: content.id, info: info }, groupData.data?.user_data, groupLook.look?.model_data);
        const purchaseTypes = getContentPurchaseTypes({ id: content.id, locked: locked, info: info }, groupData.data?.user_data, groupLook.look?.model_data);
        const redirectUrl = getContentRedirectUrl(locked, content, data.type, Orientation.Landscape, intermediatePage ?? GroupPreviewPage.Disabled, data);
        return {
            id: contentObj.id,
            contentType: contentType,
            contentContextType: contentType,
            title: contentObj.title,
            description: contentObj.description,
            redirectUrl: redirectUrl,
            image: image ?? undefined,
            flags: flags,
            orientation: Orientation.Landscape,
            ageRestriction: ageRestriction,
            releaseDate: targetDate,
            duration: duration,
            purchaseTypes: purchaseTypes,
        };
    }) ?? [];
    // LIB | Stato dell'autoplay persistito in localStorage e condiviso tra tutte
    // le istanze montate (vedi hook use-autoplay).
    const [autoplay, setAutoplay] = useAutoplay("autoplay", true);
    const handleAutoplayChange = (enabled) => {
        setAutoplay(enabled);
        onAutoplayChange?.(enabled);
    };
    const autoplaySwitchId = React.useId();
    return (_jsxs("div", { className: `${className ?? ""} relative flex min-h-0 min-w-0 flex-1 flex-col gap-3 overflow-hidden select-none`, children: [(data.title || showAutoplay) && (_jsxs("div", { className: "flex flex-row items-center justify-between gap-3", children: [_jsx("span", { className: "text-generic text-base md:text-2xl", children: data.title }), showAutoplay && (_jsxs("div", { className: "flex shrink-0 flex-row items-center gap-2", children: [_jsx(Label, { htmlFor: autoplaySwitchId, className: "text-description cursor-pointer text-xs whitespace-nowrap md:text-sm", children: t("autoplay") }), _jsx(Switch, { id: autoplaySwitchId, checked: autoplay, onCheckedChange: handleAutoplayChange, "aria-label": t("autoplay"), className: "data-[state=checked]:bg-group-custom! cursor-pointer" })] }))] })), _jsx(GenericSwiper, { data: slides, className: "min-h-0", selectedId: selectedId, swiperOrientation: swiperOrientation, slideOrientation: Orientation.Landscape, slideConfig: {
                    landscape: {
                        mouseOver: false,
                        mouseOverPreview: false,
                        preview: false,
                        dataLocation: dataLocation,
                        height: "h-42!",
                        width: "w-auto!", // EUG | 17/09/2026 | Ho provato a mettere w-1/2! per fare un modo tale che sia la meta dello spazio tra i dati della scheda e la scheda stessa, ma la scheda perde aspect-video inquel caso quindi messo w-auto!
                        gap: 12,
                    },
                }, onReachEnd: onReachEnd })] }));
}
